import { Link } from 'react-router-dom';

export default function HeroSection() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '亚洲无码正版内容平台推荐指南',
    url: 'https://shakea1.cn',
    description: '正版授权内容平台推荐、观看指南及版权合规说明，帮助用户安全合法获取亚洲无码影音资源。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://shakea1.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="Hero区域">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20digital%20media%20lounge%20interior%20with%20warm%20ambient%20lighting%20and%20soft%20golden%20accents%2C%20modern%20sleek%20architecture%20with%20glass%20partitions%2C%20comfortable%20seating%20area%2C%20subtle%20geometric%20patterns%20on%20walls%2C%20cinematic%20mood%20with%20deep%20warm%20shadows%2C%20premium%20atmosphere%2C%20professional%20editorial%20photography%20with%20soft%20focus%20background&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="亚洲无码正版内容平台推荐指南"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        <div className="absolute inset-0 flex items-center justify-center px-4">
          <div className="text-center max-w-3xl w-full">
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight">
              亚洲无码正版内容平台推荐指南
            </h1>
            <p className="text-sm md:text-base text-white/80 mb-6 md:mb-8 max-w-xl mx-auto leading-relaxed">
              为您提供正版授权内容平台推荐、观看指南及版权合规说明，帮助您安全、合法地获取亚洲无码相关影音资源，了解平台资质与内容分级制度。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/article/how-to-choose-legal-platform"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg text-sm font-medium transition-all whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-guide-line"></i>
                </span>
                查看选平台指南
              </Link>
              <Link
                to="/category/japan-uncensored"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white rounded-lg text-sm font-medium transition-all whitespace-nowrap border border-white/20"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-earth-line"></i>
                </span>
                浏览日本无码平台
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}